<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Audit Trails",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Audit Trails",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Audit Trails",
          active: true,
        },
      ],
      totalRows: 1,
      clientCurrentPage: 1,
      clientPerPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        type: 10,
        branch_id: 0
      },
      types: [
        {name: "All Types",id: 10},
        {name: "Login",id: 1},
        {name: "Sale",id: 2},
        {name: "Stock",id: 3},
        {name: "Management",id: 4},
        {name: "Finance",id: 5},
      ],
      IsServerPaginated: true,
    };
  },
  computed: {
    ...mapState("general", ["audits"]),
    ...mapGetters("general", ["Audits","filterStatus","AuditsPagination"]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),

    /**
     * Total no. of records
     */

    rows() {
       return this.IsServerPaginated
        ? this.AuditsPagination.total
        : this.Audits
        ? this.Audits.length
        : 0;
    },

     currentPage: {
      get() {
        return this.IsServerPaginated
          ? this.AuditsPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },

    perPage: {
      get() {
        return this.IsServerPaginated
          ? this.AuditsPagination.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.serverPerPage = value;
          this.handlePageChange(1);
        } else {
          this.clientPerPage = value;
        }
      },
    },

    /**
     * Todo list of records
     */
  },

  methods: {
    ...mapActions({
      FetchAudits: "general/fetchAudits",
      FetchBranches: "auth/fetchBranches",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    filterReport() {
      this.clientCurrentPage = 1;
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.serverPerPage;

      this.FetchAudits(payload);
    },

    handlePageChange(newPage) {
      if (this.IsServerPaginated) {
        let payload = {
          ...this.data,
          page: newPage,
          per_page: this.serverPerPage,
        };
        this.FetchAudits(payload);
      }
    },

  },
  created() {
    this.FetchAudits(this.data);
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row" v-if="branchid == 0">              
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="data.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>                            
            </div>
            <div class="row">
              <h4>
                <center>Audit Trails for {{ data.datefrom }} - {{ data.dateto }}</center>
              </h4>
              <div class="col-4">
                <div class="form-group">
                  <label>Type</label>
                  <model-list-select
                    :list="types ? types : []"
                    v-model="data.type"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Audit Category"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <table
              class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
              >
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>BRANCH</th>
                    <th>ACTIVITY</th>
                    <th>CATEGORY</th>
                    <th>USER</th>
                    <th>DATE/TIME</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in Audits" :key="index">
                    <td>{{ AuditsPagination.from + index }}</td>
                    <td>{{ item.branch }}</td>
                    <td>{{ item.activity }}</td>
                    <td>
                      <span v-if="item.type==1">Login</span>
                      <span v-if="item.type==2">Sale</span>
                      <span v-if="item.type==3">Stock</span>
                      <span v-if="item.type==4">ManageMent</span>
                      <span v-if="item.type==5">Finance</span>
                    </td>
                    <td>{{ item.user }}</td>
                    <td>{{ item.createddate }}</td>
                  </tr>
                </tbody>

                 <tbody v-if="filterStatus">
                    <tr>
                      <td :colspan="14" class="text-center">
                        <div class="text-warning my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="
                      !filterStatus && (!Audits || Audits.length === 0)
                    "
                  >
                    <tr>
                      <td :colspan="14" class="text-center">
                        No records found for the selected criteria.
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
